import { FC } from 'react'
import { useField } from 'react-final-form'
import isURL from 'validator/lib/isURL'

import TextField from '../molecules/TextField'

type Props = {
  isConfirm: boolean
  required?: boolean
}

const NAME = 'socialNetworkUrls'

const SocialNetworkUrlsField: FC<Props> = ({ isConfirm, required = false }) => {
  const {
    input: { value },
  } = useField(NAME)

  if (isConfirm && !value) return null

  return (
    <TextField
      label='あなたのことがわかるURL'
      name={NAME}
      isConfirm={isConfirm}
      placeholder='SNS（Facebook・Twitterなど）やブログ、noteなどあなたのことがわかるURLを記入してください'
      helperText='SNSやオンライン履歴書などのURLをご記入ください'
      required={required}
      validate={(value) => {
        if (!value) return
        if (!isURL(value)) {
          return `URLの形式に誤りがあります`
        }
      }}
    />
  )
}

SocialNetworkUrlsField.displayName = 'socialNetworkUrls'

export default SocialNetworkUrlsField
